import { cn } from "../../ui/utils";

export function TranscriptSeparator({
  label,
  sublabel,
  emphasis = false,
}: {
  label: string;
  sublabel?: string;
  emphasis?: boolean;
}) {
  return (
    <div
      role="separator"
      aria-label={sublabel ? `${label}, ${sublabel}` : label}
      className="flex items-center gap-2.5 py-0.5 select-none"
    >
      <span
        aria-hidden
        className={cn(
          "h-px flex-1",
          emphasis
            ? "bg-gradient-to-r from-transparent to-primary/30"
            : "bg-gradient-to-r from-transparent to-border dark:to-white/10",
        )}
      />
      <span className="flex shrink-0 items-baseline gap-1.5">
        <span
          className={cn(
            "text-[0.6875rem] font-medium leading-none tracking-wide",
            emphasis ? "text-primary" : "text-muted-foreground",
          )}
        >
          {label}
        </span>
        {sublabel && (
          <span className="text-[0.625rem] leading-none text-muted-foreground/70">{sublabel}</span>
        )}
      </span>
      <span
        aria-hidden
        className={cn(
          "h-px flex-1",
          emphasis
            ? "bg-gradient-to-l from-transparent to-primary/30"
            : "bg-gradient-to-l from-transparent to-border dark:to-white/10",
        )}
      />
    </div>
  );
}
